/** A Settings card (screenshots/51): title, optional subtitle, rows. Shared by Settings.tsx and its sections. */
import type { ReactNode } from "react";

export function Card({ id, title, sub, children }: { id: string; title: string; sub?: string; children: ReactNode }) {
  return (
    <section className="set-card" id={id} aria-labelledby={`${id}-title`} data-section={id}>
      <header className="set-card__head">
        <h2 id={`${id}-title`}>{title}</h2>
        {sub && <p>{sub}</p>}
      </header>
      {children}
    </section>
  );
}
